import React from "react";
import style from "./PopupLoader.scss";
import { Popup } from "../../notify/Popup";
import { Spinner } from "../Spinner";

export const PopupLoader = ({ visible, label }) => {
    return (
        <Popup visible={visible} size="auto">
            <div className={style.base}>
                <div className={style.wrapper}>
                    <div className={style.dots}>
                        <Spinner size="large" color="contrast" />
                    </div>

                    {label ? <div className={style.label}>{label}</div> : null}
                </div>
            </div>
        </Popup>
    );
};

PopupLoader.defaultProps = {
    visible: true
};
